/**
 * Terms & Conditions version model.
 */
export class TermsVersion {
    constructor(data = {}) {
        this.id = data.id || null;
        this.version = data.version || 0;
        this.title = data.title || '';
        this.content = data.content || '';
        this.isActive = Boolean(data.isActive);
        this.createdBy = data.createdBy ?? null;
        this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
        this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
    }

    getVersionLabel() {
        return `نسخه ${this.version}`;
    }

    getFormattedUpdatedAt() {
        if (!this.updatedAt) return '-';
        return this.updatedAt.toLocaleDateString('fa-IR');
    }

    getFormattedCreatedAt() {
        if (!this.createdAt) return '-';
        return this.createdAt.toLocaleDateString('fa-IR');
    }
}

export default TermsVersion;